export class InvitacionTrabajoDTO {
    constructor(
        public totalOfertado: number,
        public incluyeMateriales: boolean,
        public fechaInicioSolicitada: string,
        public fechaTerminoSolicitada: string,
        public fechaVigencia: string,

        public rutContratistas: number[]
    ) {
        this.totalOfertado = totalOfertado;
        this.incluyeMateriales = incluyeMateriales;
        this.fechaInicioSolicitada = fechaInicioSolicitada;
        this.fechaTerminoSolicitada = fechaTerminoSolicitada;
        this.fechaVigencia = fechaVigencia;

        this.rutContratistas = rutContratistas;
    }
}
